<template>
  <div class="app">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col cols="2">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col cols="1">
          <v-switch dense v-model="form.active" label="Ativo" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
            v-model="choicedGroups"
            :items="gruposDeRotas"
            multiple
            dense
            label="Grupos de rotas"
            @change="eventChange"
          >
            <template v-slot:selection="{ item, index }" >
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ choicedGroups.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon :color="choicedGroups.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
        <v-col>
          <v-select
            dense
            v-model="form.rota_id"
            v-show="choicedGroups.length > 0"
            :error-messages="rotaIdErrors"
            :items="filtredItens"
            label="Rota"
            @change="zerarRegex()"
            @input="$v.form.rota_id.$touch()"
            @blur="$v.form.rota_id.$touch()"
          />
        </v-col>
        <v-col>
          <v-select
            dense
            v-show="form.rota_id && choicedGroups.length > 0"
            v-model="form.regex_id"
            :error-messages="regexIdErrors"
            :items="buscaRegex"
            label="Ação da Rota"
            @input="$v.form.regex_id.$touch()"
            @blur="$v.form.regex_id.$touch()"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import { registerVuexModule } from '@/utils/vuexUtils'

import tarefasStore from '../_store'
import { validateData, validateComputed } from '../_validates/validateAtivarDesativarRegra'

export default {
  name: 'DesativarRegra',
  props: {
    acao: Object,
  },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: 'DESATIVAR AÇÃO',
      tipo: 'desativarRegra',
      rota_id: '',
      regex_id: '',
      active: true,
    },
    rotas: [],
    rotasParaMontarRegex: [],
    show: false,
    showSkeleton: true,
    choicedGroups: [],
    filtredItens: [],
    gruposDeRotas: [],
    allRoutes: [],
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('acaoDesativarRegraAgendamentoTarefasModulePABXStore', ['getRotas', 'getGruposDeRotas']),
    ...validateComputed,
    buscaRegex() {
      let regex = []
      const indexRotas = this.rotas.findIndex(rota => rota.value === this.form.rota_id)

      if (indexRotas !== -1) {
        this.rotasParaMontarRegex[indexRotas].regex.forEach(regexRota => {
          if (typeof regexRota.acao.description !== 'undefined') {
            regex.push({ text: `${regexRota.prioridade} - ${regexRota.acao.description}`, value: regexRota.regex_id })
          } else {
            regex.push({ text: `${regexRota.prioridade} - Sem descrição`, value: regexRota.regex_id })
          }
        })
      }
      return regex
    },
     todosGruposSelecionados() {
      return this.choicedGroups.length === this.gruposDeRotas.length
    },
    algunsGruposSelecionados() {
      return this.choicedGroups.length > 0 && !this.todosGruposSelecionados
    },
    icon() {
      if (this.todosGruposSelecionados) return 'mdi-close-box'
      if (this.algunsGruposSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  async created() {
    registerVuexModule(this.$store, 'acaoDesativarRegraAgendamentoTarefasModulePABXStore', tarefasStore)

    await Promise.all([this.listarRotas(), this.listarGruposDeRotas()])

    this.rotas = this.getRotas.map(rota => ({ text: rota.description, value: rota._id }))
    this.allRoutes = [...this.getRotas]
    this.rotasParaMontarRegex = [...this.getRotas]
    this.gruposDeRotas = this.getGruposDeRotas.map(grupo => ({ text: grupo.description, value: grupo._id }))
    this.form = Object.assign({}, this.acao)

    if(this.acao.rota_id !== '') {
      let route = this.allRoutes.find(element => element._id === this.acao.rota_id)
      let groups = this.gruposDeRotas.map(grupo => grupo.value)
      this.choicedGroups.push(groups.find(element => element === route.group))
      this.filtrar()
    }

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('acaoDesativarRegraAgendamentoTarefasModulePABXStore', ['listarRotas', 'listarGruposDeRotas']),
    zerar() {
      this.form.rota_id = ''
      this.form.regex_id = ''
    },
    zerarRegex() {
      this.form.regex_id = ''
    },
    toggle() {
      this.$nextTick(() => {
        if (this.todosGruposSelecionados) {
          this.choicedGroups.splice(0)
        } else {
          this.choicedGroups.splice(0)
          this.choicedGroups = this.gruposDeRotas.map(grupo => grupo.value)
        }
        this.filtrar()
      })
    },
    filtrar() {
      this.filtredItens = []
      this.allRoutes.forEach(rota => {
        if(this.choicedGroups.includes(rota.group)) {
          this.filtredItens.push(this.rotas.find(element => element.value === rota._id))
        }
      })
    },
    eventChange() {
      this.zerar()
      this.zerarRegex()
      this.filtrar()
    }
  },

  watch: {
    form: {
      deep: true,
      handler(novo) {
        this.$emit('form', novo)
        this.$emit('error', this.$v)
      },
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
